import { CreateWith } from '../types/createWith';
import { fetchImageAsBase64 } from './images';

declare const window: any;
declare const global: any;
declare const globalThis: any;

const g = typeof window === 'object' ? window : typeof globalThis === 'object' ? globalThis : typeof global === 'object' ? global : null;

// Mock implementation for development environment
if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined' && !window.createWith) {
	console.log('Setting up mock createWith for development');
	window.createWith = {
		get: async () => {
			// example expected return:
			// {"image": {"id": 19, "image": "data:image/png;base64,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", "name": "Test"}}
			console.log('Mock get() called - fetching bitmap.png');
			// Fetch the bitmap.png from public folder and convert to base64
			try {
				// if (1) throw new Error('test error');
				const base64Image = await fetchImageAsBase64('/bitmap.png');
				return {
					image: {
						id: 1,
						image: base64Image,
						name: 'Test bitmap',
					},
				};
			} catch (error) {
				console.error('Failed to load bitmap image:', error);
				return null;
			}
		},
		post: async (base64: string) => {
			console.log('Mock post() called with data length:', base64?.length || 0);
			alert('Mock post() called - Image would be saved to the mobile app');
			return { success: true };
		},
		close: async () => {
			console.log('Mock close() called');
			alert('Mock close() called - WebView would be closed');
			return { success: true };
		},
		local_save: async (base64: string) => {
			console.log('Mock local_save() called with data length:', base64?.length || 0);

			try {
				// Check if File System Access API is supported
				if ('showSaveFilePicker' in window) {
					// Convert data URL to blob
					const fetchResponse = await fetch(base64);
					const blob = await fetchResponse.blob();

					// Use the File System Access API
					// @ts-ignore - TypeScript might not recognize showSaveFilePicker yet
					const fileHandle = await window.showSaveFilePicker({
						suggestedName: 'CreateWith.png',
						types: [
							{
								description: 'PNG Image',
								accept: { 'image/png': ['.png'] },
							},
						],
					});

					// Create a FileSystemWritableFileStream to write to
					const writable = await fileHandle.createWritable();

					// Write the blob to the file
					await writable.write(blob);

					// Close the file and write the contents to disk
					await writable.close();

					console.log('Image saved using File System Access API');
					return { success: true };
				} else {
					// Fallback for browsers without File System Access API
					const link = document.createElement('a');
					link.download = 'CreateWith.png';
					link.href = base64;
					link.click();

					console.log('Image saved using download link fallback');
					return { success: true };
				}
			} catch (err) {
				// User canceled or API error
				if (err.name === 'AbortError') {
					console.log('Save canceled by user');
					return { success: false, canceled: true };
				} else {
					console.error('Error saving file:', err);
					alert('Error saving file: ' + err.message);
					return { success: false, error: err.message };
				}
			}
		},
	};
}

export const getCreateWith = (): CreateWith | undefined => {
	if (typeof g !== 'undefined' && g?.createWith) return g.createWith;
	return undefined;
};
